import { SuggestedQuestion } from './actions';

interface GlobalAskAicaService {
    openModalWithMessage: (message: string, flowKey?: string) => void;
    registerAskAicaInstance: (
        openModalFn: (message?: string, flowKey?: string) => void,
        sendMessageFn: (message: string, sources?: string[], flowKey?: string) => void,
    ) => void;
}

class AskAicaServiceImpl implements GlobalAskAicaService {
    private openModal: ((message?: string, flowKey?: string) => void) | null = null;
    private sendMessage: ((message: string, sources?: string[], flowKey?: string) => void) | null = null;

    registerAskAicaInstance(
        openModalFn: ((message?: string, flowKey?: string) => void) | null,
        sendMessageFn: ((message: string, sources?: string[], flowKey?: string) => void) | null,
    ): void {
        this.openModal = openModalFn;
        this.sendMessage = sendMessageFn;
    }

    openModalWithMessage(message: string, flowKey?: string): void {
        if (this.openModal && this.sendMessage) {
            this.openModal(message, flowKey);
        } else {
            console.error('AskAica instance not registered. Make sure the global AskAicaV2 component is mounted.');
        }
    }
}

export const globalAskAicaService = new AskAicaServiceImpl();

export const handleSuggestedQuestionClick = (question: string | SuggestedQuestion, flowKey?: string): void => {
    const text = typeof question === 'string' ? question : question.text;
    const resolvedFlowKey = flowKey ?? (typeof question === 'string' ? undefined : question.flowKey);
    globalAskAicaService.openModalWithMessage(text, resolvedFlowKey);
};
